import SectionHeading from "./SectionHeading";
import { topicCategories } from "@/mocks/home";

export default function TopicCategories() {
  return (
    <section id="categories" className="w-full bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          badge="Topics"
          title="51cg5 热门专题 · 分类追踪"
          desc="按题材分区追踪，热门榜与实时热度在不同分类下各自成榜。"
          linkText="全部分类"
          linkHref="#categories"
        />

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {topicCategories.map((cat) => (
            <a
              key={cat.id}
              href="#categories"
              className="group flex cursor-pointer items-center gap-3 rounded-lg border border-background-200/70 bg-background-100 p-4 transition-colors hover:border-accent-300 hover:bg-accent-50"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-600 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <span className="min-w-0">
                <span className="block truncate font-heading text-sm font-bold text-foreground-950">{cat.name}</span>
                <span className="mt-0.5 block text-[11px] text-secondary-500">{cat.count} 条热议</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}